import React from 'react';

interface DecisionTreeContextProps {
  isMounted: 'split' | 'main' | null;
  toggleMounted: () => void;
  setPreference: (preference: 'split' | 'main') => void;
}

export const DecisionTreeContext = React.createContext<DecisionTreeContextProps | undefined>(undefined);

export default function useDecisionTreeContext() {
  const context = React.useContext(DecisionTreeContext);
  if (!context) {
    throw new Error('useDecisionTreeContext must be used within a DecisionTreeContextProvider');
  }
  return context;
}
